import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { ConfigOutlet } from '../components/ConfigOutlet';
import { DialogOutletEdit } from '../components/DialogOutletEdit';
import { newOutlet } from '../actions/NewOutlet';
export const ConfigOutlets = (_props) => {
    const defOutlets = useAppSelector(state => state.definitions.outlets);
    const outlets = Object.values(defOutlets).sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
    const dispatch = useAppDispatch();
    const rows = [];
    for (const outlet of outlets) {
        rows.push(_jsx(ConfigOutlet, Object.assign({}, outlet), outlet.id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx(DialogOutletEdit, {}), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: () => dispatch(newOutlet()), children: "\u00A0L\u00E4gg till kontakt...\u00A0" }) }), _jsx("div", { className: "config-rows config-outlets", children: rows })] }));
};
